<template lang="pug">
  v-main
    v-container
        v-card
            v-toolbar(class="elevation-0" color='white')
                v-toolbar-title Edit Account
            v-divider
            v-alert(
                icon="info"
                text
                type="info"
            ) Info: Editing this data will not change memo in progress. Data changes will be updated when new memo.
            v-card-text
                //- v-row(no-gutters)
                //-     v-col(cols="4") 
                //-         v-subheader(color="black") Name
                //-     v-col(cols="5")
                //-         v-text-field(
                //-             v-model='users.full_name' 
                //-             label='Name'
                //-             :rules="[rules.required]"
                //-         )

                //- v-row(no-gutters)
                //-     v-col(cols="4") 
                //-         v-subheader Email Login
                //-     v-col(cols="5")
                //-         v-text-field(
                //-             v-model='users.email' 
                //-             label='Email'
                //-             type="email" 
                //-             disabled
                //-         )

                //- v-row(no-gutters)
                //-     v-col(cols="4") 
                //-         v-subheader Phone Number
                //-     v-col(cols="5")
                //-         v-text-field(
                //-             v-model='users.msisdn' 
                //-             label='Phone Number' 
                //-             :rules="[rules.required]"
                //-         )

                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(color="black") 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Name&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.full_name' 
                            label='Name'
                            :rules="[rules.required]"
                            @keypress="isLetter($event)"
                        )
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(color="black") 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Alias Name&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.alias' 
                            label='Alias'
                            :rules="[rules.required]"
                            @keypress="isLetter($event)"
                        )
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(style="height: 16px;") 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Business Unit Email&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                        small(style="color: #F08703;" class="ml-4") *Email for notification memo 
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.email' 
                            label="Email (Don't use personal e-mail)"
                            type="email" 
                            :rules="[rules.required, rules.email]"
                        )

                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(style="height: 16px;") 
                            | &nbsp;Business Unit Phone Number&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Optional)
                        small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
                    v-col(cols="5")
                        vue-tel-input(
                            @validate="telValidate" 
                            v-model="bu.msisdn"
                            style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
                        )
                        p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format


                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Position&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.position' 
                            label='Position' 
                            :rules="[rules.required]"
                        )
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Business Unit&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.bisnis_unit' 
                            label='Business Unit' 
                            disabled
                        )
                
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Status&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-radio-group(
                            v-model="bu.is_active"
                            row)
                            v-radio(
                                label="Active"
                                value="active")
                            v-radio(
                                label="Non Active"
                                value="nonactive")
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Group&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-radio-group(
                            v-model="bu.is_admin"
                            row)
                            v-radio(
                                label="Admin"
                                value="yes")
                            v-radio(
                                label="User"
                                value="no")

                //- Container dengan background merah untuk Payment Voucher Access dan Auto Notif Payment Request
                v-row(no-gutters)
                    v-col(cols="9")
                        v-card(
                            class="pa-4 mb-4 pt-1"
                            style="border: 1px solid #ef5350;"
                        )
                            //- Title di atas Payment Voucher Access
                            v-col(class="d-flex align-center" style="margin-left: -10px; position: relative;")
                                v-subheader(
                                    style="color: #000; font-weight: 600; font-size: 16px; height: auto; padding-left: 0;"
                                ) Payment Voucher Activation
                                v-icon(
                                    small
                                    color="blue"
                                    style="cursor: pointer; margin-left: -12px;"
                                    @mouseenter="showTooltipHeader = true"
                                    @mouseleave="showTooltipHeader = false"
                                ) mdi-information
                                .custom-tooltip-header(v-if="showTooltipHeader") 
                                    | This process follows the Payment Request and is performed by the Finance Team.

                            v-row(no-gutters style="margin-left: -15px;" align="center" class="mb-7")
                                v-col(cols="4" class="d-flex align-center") 
                                    v-subheader(style="height: auto; padding-top: 0; padding-bottom: 0;") Payment Voucher Access
                                v-col(cols="6" class="d-flex align-center")
                                    v-checkbox(
                                        v-model="bu.is_payment_voucher"
                                        label="Yes"
                                        hide-details
                                        class="mt-0 pt-0"
                                    )

                            v-row(
                                no-gutters 
                                align="center"
                                style="margin-left: -15px;"
                            )
                                v-col(cols="4" class="d-flex align-center" style="position: relative;")
                                    v-subheader(style="height: auto; padding-top: 0; padding-bottom: 0;") Auto Notif Payment Request
                                    v-icon(
                                        small
                                        color="blue"
                                        style="cursor: pointer; margin-left: -12px;"
                                        @mouseenter="showTooltip = true"
                                        @mouseleave="showTooltip = false"
                                    ) mdi-information
                                    .custom-tooltip(v-if="showTooltip") 
                                        | When the flag is ‘Yes’, the system automatically sends an email to the user upon full approval of a Payment Request.
                                v-col(cols="6" class="d-flex align-center")
                                    v-checkbox(
                                        v-model="bu.is_auto_notif_pr"
                                        label="Yes"
                                        :disabled="!bu.is_payment_voucher"
                                        hide-details
                                        class="mt-0 pt-0"
                                    )

                v-card-actions(class="my-8")
                    v-btn(
                        v-if="$store.state.dataUsers.role=='super_user'"
                        class="custom__padding-btn" 
                        @click="$router.push('/users-general')") Back
                    v-btn(
                        v-else-if="$store.state.dataUsers.role=='admin'"
                        class="custom__padding-btn" 
                        @click="$router.push('/users')") Back
                        
                    v-btn(
                        color='blue-secondary' 
                        class="custom__padding-btn" 
                        :disabled="!formIsValid"
                        @click="update()") Update

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
export default {
  data: () => ({
    validNumber:  false,
    showTooltip: false,
    showTooltipHeader: false,
    users: {
        full_name: '',
        email: '',
        msisdn: ''
    },
    bu: {
        full_name: '',
        alias: '',
        email: '',
        msisdn: '',
        position: '',
        bisnis_unit: '',
        is_active: '',
        is_admin: false,
        is_payment_voucher: false,
        is_auto_notif_pr: false
    },
    rules: {
        required: value => !!value || 'This field is required.',
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid email format'
        },
        number: v => /^\d+$/.test(v)||'Must start 08 or 62',
        msisdn: value => (value && value.length >= 10) || 'Mobile number cannot be less than 10',
    },
    bisnis_units: [],
    overlay: false,
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
     formIsValid () {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return (
        this.bu.full_name &&
        this.bu.alias &&
        pattern.test(this.bu.email) &&
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.position &&
        this.bu.bisnis_unit &&
        this.bu.is_active
      )
    },
  },
  watch: {
    'bu.is_payment_voucher'(newVal) {
      if (!newVal) {
        this.bu.is_auto_notif_pr = false;
      }
    }
  },
  mounted(){
    this.getData();
    // this.getBisnisUnit();
  },
  methods: {
    telValidate(telnumber) {  
        if (telnumber.valid || this.bu.msisdn.length == 0) this.validNumber = true  
        else  this.validNumber = false
    },
    getData() {
        this.overlay = true
        let token = localStorage.getItem('token');
        axios.get(process.env.VUE_APP_API+`/users/admin/${this.$route.params.id}`,
        {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            this.overlay = false
            this.bu.full_name = res.data.data.full_name
            this.bu.alias = res.data.data.alias
            this.bu.email = res.data.data.email
            this.bu.msisdn = res.data.data.msisdn ? `+${res.data.data.msisdn}` : "";
            this.bu.position = res.data.data.position
            this.bu.bisnis_unit = res.data.data.business_unit.bu_name
            this.bu.is_active = res.data.data.is_active == true ? 'active' : 'nonactive'
            this.bu.is_admin = res.data.data.is_admin == true ? 'yes' : 'no'
            this.bu.is_payment_voucher = res.data.data.is_payment_voucher === true
            this.bu.is_auto_notif_pr = res.data.data.is_auto_notif_pr === true
        })
        .catch(err => {
            this.overlay = false
            this.$toasted.error(err, { icon : 'error'});
        })
        .finally(() => {
            this.overlay = false
            this.loading = false
        });
    },
    update() {
        this.overlay = true
        this.$store.dispatch("updateDataBuToUsers", { bu:this.bu, bu_id: `${this.$route.params.id}`, user_id: `${window.location.toString().split("/").pop()}`})
            .then(res => {
            this.overlay = false
            if (this.showDrawer) this.$store.commit("toggleDrawer");
                if (res.data.status == 200) {
                    this.$toasted.success("Success, the account was successfully updated", { icon : 'check_circle'});
                    
                    if( this.$store.state.dataUsers.role == 'super_user' ) {
                        return this.$router.push("/users-general");
                    } else {
                        return this.$router.push("/users");
                    }
                } else {
                    this.$toasted.error("Failed to Update Data", { icon : 'error'});
                }
            })
            .catch(err => {
                this.overlay = false
                this.$toasted.error(err.response.data.error, { icon : 'error'})
            });
    },
    isNumber(e) {
        let char = String.fromCharCode(e.keyCode); 
        if(/^[0-9]+$/.test(char)) return true; 
        else e.preventDefault(); 
    },
    isLetter(e) {
        let char = String.fromCharCode(e.keyCode); 
        if(/^[A-Za-z0-9 ]+$/.test(char)) return true; 
        else e.preventDefault(); 
    }
    // getBisnisUnit() {
    //     if (this.$store.state.dataUsers.user) {
    //         this.bisnis_units = this.$store.state.dataUsers.user.bu;
    //     } else {
    //         this.bisnis_units = this.$store.state.dataUsers.bu;
    //     } 
    // }
  }

};
</script>

<style>
    button.custom__padding-btn{
        padding: 1.4rem 2rem !important;
    }

    .v-toolbar__content {
        box-shadow: none;
    }

    .custom-tooltip-header {
        position: absolute;
        bottom: 75%;
        left: 50%;
        transform: translateX(-94%);
        margin-bottom: 12px;
        background-color: #616161;
        color: white;
        padding: 10px 16px;
        border-radius: 4px;
        font-size: 14px;
        white-space: normal;
        max-width: 400px;
        width: max-content;
        z-index: 1000;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .custom-tooltip-header::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-color: #616161;
    }

    .custom-tooltip {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-33%);
        margin-bottom: 12px;
        background-color: #616161;
        color: white;
        padding: 10px 16px;
        border-radius: 4px;
        font-size: 14px;
        white-space: normal;
        max-width: 400px;
        width: max-content;
        z-index: 1000;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .custom-tooltip::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-color: #616161;
    }
</style>